import React, { useCallback, useEffect, useMemo, useState } from "react";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import {
  Modal,
  Button,
  Typography,
  Tag,
  List,
  Checkbox,
  Input,
  Radio,
  message,
} from "antd";
import {
  BellOutlined,
  DeleteOutlined,
  EditOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import "../../App.css";
import { URL } from "../../helper/Mainurl";
import CheckboxLogo from "../../Assets/calender/Checkbox.png";
import DetailsList from "../DetailsList";
import DateModalTask from "./DateModalTask";
import TimeSelect from "./TimeSelect";
import Reminder from "./Reminder";
import FloatLabel from "../FloatLabel";
import ChecklistComponent from "../ChecklistComponent";
import moment from "moment";
import ColorsModal from "./ColorsModal";
import AssignToModal from "./AssignToModal";
import CollaborationModal from "./CollaborationModal";
import RepeatModal from "./RepeatModal";
import {
  AssessmentOutlined,
  AssignmentOutlined,
  ColorLensOutlined,
  RepeatOnOutlined,
} from "@mui/icons-material";
import axios from "axios";
import UserAvatarList from "./UserAvatarList";
import DeleteConfirmationModal from "../DeleteConfirmationModal";
import RecurringEventModal from "../../Components/Modals/DeleteAndUpdateModal/DeleteAndUpdateModal";
import { useUserInfo } from "../../contexts/userInfo";
const { Title, Text, Paragraph } = Typography;

const token = localStorage.getItem("authToken"); // Get token from localStorage

const ViewTask = ({ isOpen, onCancel, eventData, onSuccess }) => {
  const { userInfo } = useUserInfo();
  const [activeTab, setActiveTab] = useState("1");
  const [progressStatus, setProgressStatus] = useState([]);
  const [displayName, setDisplayName] = useState([]);
  const [priority, setPriority] = useState([]);
  const [taskData, setTaskData] = useState({
    title: "",
    description: "",
    location: "",
  });
  const [error, setError] = useState(false);
  const [editView, setEditView] = useState(false);
  const [selectedDisplayId, setSelectedDisplayId] = useState(null);
  const [selectedPriorityIds, setSelectedPriorityIds] = useState(null);
  const [checklist, setChecklist] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [showRemModal, setShowRemModal] = useState(false);
  const [descSelectedReminder, setDescSelectedReminder] =
    useState("No reminder");
  const [switchStates, setSwitchStates] = useState(false);
  const [eventType, setEventType] = useState("");
  const [switchTimeStates, setSwitchTimeStates] = useState(false);
  const [switchStatesRem, setSwitchStatesRem] = useState(false);
  const [assignBy, setAssignBy] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const [selectedTime, setSelectedTime] = useState({
    start: null,
    end: null,
  });

  const [deletedChecklistIds, setDeletedChecklistIds] = useState([]);
  const [selectReminder, setSelectReminder] = useState(false);
  const [selectedReminder, setSelectedReminder] = useState("No reminder");
  const [inputText, setInputText] = useState("");
  const [inputTextDesc, setInputTextDesc] = useState(null);
  const [locationText, setLocationText] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [AssignData, setAssignData] = useState([]);
  const [collaboratorsName, setCollaboratorsName] = useState([]);

  const [assignName, setAssignName] = useState("");
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [showCollaborationModal, setShowCollaborationModal] = useState(false);
  const [switchStatesCollaboration, setSwitchStatesCollaboration] =
    useState(false);
  const [selectedCollaborators, setSelectedCollaborators] = useState([]);
  const [showColorModal, setShowColorModal] = useState(false);
  const [switchStatesColor, setSwitchStatesColor] = useState(false);
  const [colorMetaData, setColorMetaData] = useState([]);
  const [descSelectedColor, setDescSelectedColor] = useState("No color");
  const [selectedColorForPayload, setSelectedColorForPayload] = useState("");
  const [selectedColor, setSelectedColor] = useState(null);
  const [initialSelectedColorId, setInitialSelectedColorId] = useState(null);
  const [CollaborateData, setCollaborateData] = useState([]);
  const [permission, setPermission] = useState([]);
  const [repeatOption, setRepeatOption] = useState([]);
  const [adjusWeekend, setAdjustWeekend] = useState([]);
  const [metaLoading, setMetaLoading] = useState(false);
  const [showRepeatModal, setShowRepeatModal] = useState(false);

  // State for switch toggle
  const [switchStatesRepeat, setSwitchStatesRepeat] = useState(false);
  const [colorConfigure, setColorConfigure] = useState(null);

  const [dummyCollaborators, setDummyCollaborators] = useState([]);
  const [getAssignee, setGetAssignee] = useState([]);
  const [getCollaboraters, setGetCollabraters] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false); // delete modal visible state
  const [selectedItemForDelete, setSelectedItemForDelete] = useState(null); // confirm deleteType
  //
  const [occurrenceDate, setOccrrenceDate] = useState(
    eventData.occurrenceDate || ""
  );
  // Repeat settings configuration
  const [repeatConfig, setRepeatConfig] = useState(null);
  const [invitees, setInvitees] = useState();
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [taskDetails, setTaskDetails] = useState(null);

  const fetchTaskDetailsById = useCallback(async () => {
    // console.log("commming_insdie_function", eventData?.task_id , !eventData?.start, eventData.occurrenceDate)
    try {
      if (!eventData?.task_id || !eventData?.start) {
        console.warn("Missing task ID or start date");
        return;
      }

      const token = localStorage.getItem("authToken");
      // const occurrenceDate =  moment(eventData.start).format("YYYY-MM-DD"); // Safe split

      const response = await axios.get(
        `${URL}/v1/calendar/task-event-details/${eventData.task_id}`,
        {
          params: {
            type: "task",
            occurrence_date: eventData.occurrenceDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("API Response:", response.data.data);
      setTaskDetails(response.data.data);
      setGetAssignee(response.data.data.assignees || []);
      setAssignBy(response.data.data.assigned_by || {});
      setLocationText(response.data.data.location || undefined);
      setGetCollabraters(response.data.data.collaborators || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  }, [eventData?.task_id, eventData?.start]);

  useEffect(() => {
    // console.log("Effect triggered - isOpen:", isOpen, "task_id:", eventData?.task_id);

    if (isOpen) {
      fetchTaskDetailsById();
    }
  }, [eventData, isOpen]);

  // Toggle repeat switch
  const handleSwitchChangeRepeat = () => {
    const newState = !switchStatesRepeat;
    setSwitchStatesRepeat(newState);

    if (newState) {
      // Show modal when turning on
      setShowRepeatModal(true);
    } else {
      // Clear config when turning off
      setRepeatConfig(null);
    }
  };

  const handleColorCancel = () => {
    setShowColorModal(false);
  };
  const handleColorSave = (selectedColor) => {
    setDescSelectedColor(selectedColor?.label_name);
    setSwitchStatesColor(selectedColor?.label_name ? true : false);
    setSelectedColor(selectedColor);
    message.success("Color added successfully");
    setShowColorModal(false);
  };
  const getRepeatDescription = () => {
    if (!switchStatesRepeat || !repeatConfig) return "No repeat";

    const { repeatType, endType, occurrences, customEndDate } = repeatConfig;

    if (!repeatType) return "No repeat";

    // Map repeatType string to a label
    const repeatLabels = {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
    };

    const repeatLabel = repeatLabels[repeatType] || "Custom";

    const endText =
      endType === "custom"
        ? `until ${moment(customEndDate).format("D MMMM YYYY")}`
        : `after ${occurrences} ${occurrences === 1 ? "year" : "years"}`;

    return `${repeatLabel} (Ends ${endText})`;
  };

  const selectedNames =
    (Array.isArray(assignedUsers)
      ? AssignData.filter((u) => assignedUsers?.some((a) => a.id === u.id))
      : []
    )
      .map((u) => u.name)
      .join(", ") || "No assign";

  // Handle saving from RepeatModal
  const handleRepeatSave = (data) => {
    // console.log("Repeat data received:", data);
    setRepeatConfig(data);
    // const {
    //   repeatType,
    //   endType,
    //   occurrences,
    //   customEndDate,
    //   adjustWeekends,
    //   excludeWeekends
    // } = repeatConfig;

    // console.log("Repeat Type:", repeatType?.value); // e.g., "weekly"
    // console.log("End Type:", endType);              // e.g., "custom" or "after"
    // console.log("Occurrences:", occurrences);       // e.g., 5
    // console.log("Custom End Date:", customEndDate); // e.g., "2025-07-01"
    // console.log("Adjust Weekends:", adjustWeekends); // e.g., "previous_friday"
    // console.log("Exclude Weekends:", excludeWeekends); // e.g., [{ id: 1, label: 'saturday' }]

    //   console.log('setRepeatConfig', repeatConfig);
    // You can perform side effects here, such as API calls or other logic

    setSwitchStatesRepeat(true);
    setShowRepeatModal(false);
  };
  const descSelectedCollaboration =
    selectedCollaborators.length > 0 || (invitees?.length ?? 0) > 0
      ? [
          ...selectedCollaborators.map((c) => c.name),
          ...(invitees || []).map((i) => i.email.split("@")[0]),
        ].join(", ")
      : "No collaborators selected";
  useEffect(() => {}, [repeatConfig]);
  // Cancel modal
  const handleRepeatCancel = () => {
    // If no config and switch is off, don't keep modal open
    if (!repeatConfig) {
      setSwitchStatesRepeat(false);
    }
    setShowRepeatModal(false);
  };

  const handleSwitchChangeCollaboration = (checked) => {
    setSwitchStatesCollaboration(checked);
  };
  const handleSwitchChangeColor = () => {
    const newState = !switchStatesColor;
    setSwitchStatesColor(newState);

    if (newState) {
      // If turning ON, open the modal
      setShowColorModal(true);
    } else {
      // If turning OFF, just turn off the switch, don't open modal
      setSelectedColor(null);
      setDescSelectedColor("No color");
    }
  };
  const handleSaveCollaboration = (selected) => {
    // console.log("Selected collaborators before state update:", selected);

    // Separate new invitees
    const newInvites = selected.filter((user) => user.newInvitee);
    const confirmedCollaborators = selected.filter((user) => !user.newInvitee);

    // Set only confirmed collaborators
    setSelectedCollaborators(confirmedCollaborators);
    // console.log("setSelectedCollaborators", selectedCollaborators)

    setSwitchStatesCollaboration(confirmedCollaborators.length > 0);
    setShowCollaborationModal(false);

    // Add new confirmed collaborators to dummyCollaborators if not already present
    const newCollaborators = confirmedCollaborators.filter(
      (sel) => !dummyCollaborators.some((c) => c.id === sel.id)
    );

    if (newCollaborators.length > 0) {
      setDummyCollaborators((prev) => [...prev, ...newCollaborators]);
    }

    // Extract and set unique invitees
    if (newInvites.length > 0) {
      const invitePayload = newInvites.map((invitee) => ({
        email: invitee.email,
        permission_id: String(invitee.permission.id),
      }));
      setSwitchStatesCollaboration(true);
      setInvitees((prev = []) => {
        const existingEmails = new Set(prev.map((i) => i.email));
        const filteredNew = invitePayload.filter(
          (i) => !existingEmails.has(i.email)
        );
        return [...prev, ...filteredNew];
      });
    }
  };
  const formatDateTimeRem = (selectedDate, selectedTime, selectedReminder) => {
    const validReminderMap = {
      5: "5 minute before",
      30: "30 minute before",
      60: "1 hour before",
      1440: "1 day before",
    };

    const formattedDate = moment(selectedDate, [
      "D MMMM YYYY",
      "DD, MMMM YYYY",
      "YYYY-MM-DD",
      "MM/DD/YYYY",
      "DD MMM YYYY",
    ]);

    if (!formattedDate.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid date" };
    }

    const formattedStartTime = moment(selectedTime?.start, [
      "HH:mm",
      "HH:mm:ss",
    ]);
    if (!formattedStartTime.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid time" };
    }

    const taskStart = moment.utc(
      `${formattedDate.format("YYYY-MM-DD")}T${formattedStartTime.format(
        "HH:mm"
      )}:00Z`
    );

    const taskStartTime = taskStart.format("YYYY-MM-DDTHH:mm:ss[Z]");
    if (!selectedReminder) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const reminderTime = moment.utc(selectedReminder);

    if (!reminderTime.isValid() || !reminderTime.isBefore(taskStart)) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const diffMinutes = taskStart.diff(reminderTime, "minutes");

    if (validReminderMap[diffMinutes]) {
      return { taskStartTime, reminderText: validReminderMap[diffMinutes] };
    }

    // Compute human-readable fallback for Customize...
    const totalMinutes = diffMinutes;
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    let parts = [];
    if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

    const customizeLabel =
      parts.length > 0
        ? `Customize...(${parts.join(", ")} before)`
        : "Customize...";

    return { taskStartTime, reminderText: customizeLabel };
  };
  const handleSelectReminder = (reminder) => {
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      reminder
    );
    setSelectedReminder(reminder);
    setDescSelectedReminder(reminderText);
    setSwitchStatesRem(!!reminder);

    // console.log("SelectedReminder>>", reminder, "Task Start Time>>", taskStartTime);
  };

  const selectTextReminder = (item) => {
    // console.log("nananan", item)
    setDescSelectedReminder(item);
  };

  const handleDateSelect = (date) => {
    console.log("datehandleDateSelect-task", date);
    setSelectedDate(date);
    setShowModal(false); // Close modal after selecting a date
    setSwitchStates(!!date); // Correctly update state
    // console.log("Selected Date:", date);
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      selectedReminder
    );

    setDescSelectedReminder(reminderText);
  };
  useEffect(() => {
    // console.log("Updated checklist:", checklist);
  }, [checklist]);
  const handleSwitchChange = () => {
    setShowModal(true);
  };
  const handleSwitchChangeTime = () => {
    setShowTimeModal(true);
  };
  const handleSwitchChangeRem = () => {
    // console.log("handleSwitchChangeRem::", switchStatesRem);
    const newState = !switchStatesRem;
    setSwitchStatesRem(newState);
    if (!newState) {
      // If the switch was ON and now turned OFF, show the modal
      // setShowRemModal(true);
      setSwitchStatesRem(false);
      setDescSelectedReminder("");
    } else {
      // If the switch was OFF and now turned ON
      setSelectedReminder(null);
      setSwitchStatesRem(true); // Ensure the switch turns ON
      setShowRemModal(true);
    }
  };

  const handleSelectDisplay = (id) => {
    setSelectedDisplayId(id); // Store only one selected ID
  };

  const handleSelectPriority = (id) => {
    setSelectedPriorityIds(id);
  };
  const handleSelectTime = (timeData) => {
    // console.log("SelectedTime:", timeData);

    const formattedStartTime = moment(timeData.start, "HH:mm");
    const formattedEndTime = moment(timeData.end, "HH:mm");

    const formattedTime = {
      start: formattedStartTime.format("HH:mm"),
      end: formattedEndTime.format("HH:mm"),
    };

    // console.log("Formatted Time:", formattedTime);

    setSelectedTime(formattedTime);
    setSwitchTimeStates(!!timeData);
    // console.log("handleSelectTime:>>>>>", selectedDate, selectedTime, selectedReminder)
    // const { taskStartTime, reminderText } = formatDateTimeRem(selectedDate, selectedTime, selectedReminder);
    // console.log("reminderText", reminderText)
    // setDescSelectedReminder(reminderText);
    setDescSelectedReminder("No reminder");
    setSwitchStatesRem(false);
  };

  useEffect(() => {
    if (eventData?.type) {
      setEventType(eventData.type === "task" ? "Task" : "Event");
    } else {
      setEventType("Unknown"); // Fallback value
    }
  }, [eventData?.type]);

  useEffect(() => {
    // console.log("Received eventData in ViewTask:", {eventData});
    if (!eventData) return;

    const startDate = moment(eventData.start);

    const repeatType = eventData.repeat_option || "daily";
    const endDate = eventData.repetition_end_date
      ? moment(eventData.repetition_end_date)
      : null;
    const endType = endDate ? "custom" : "after";

    let occurrences = 2; // default fallback
    if (endDate && startDate.isBefore(endDate)) {
      switch (repeatType) {
        case "daily":
          occurrences = endDate.diff(startDate, "days") + 1;
          break;
        case "weekly":
          occurrences = endDate.diff(startDate, "weeks") + 1;
          break;
        case "monthly":
          occurrences = endDate.diff(startDate, "months") + 1;
          break;
        default:
          break;
      }
    }

    const excludeWeekends = [];
    if (eventData.exclude_saturdays === "1") {
      excludeWeekends.push({ id: 2, label: "saturday" });
    }
    if (eventData.exclude_sundays === "1") {
      excludeWeekends.push({ id: 3, label: "sunday" });
    }

    // Only set repeatConfig and switchStatesRepeat if repeat_option or repetition_end_date is present
    if (eventData.repeat_option || eventData.repetition_end_date) {
      const values = {
        repeatType: { value: repeatType },
        endType,
        occurrences,
        customEndDate: endDate ? endDate.format("YYYY-MM-DD") : null,
        excludeWeekends,
        adjustWeekends: eventData.adjust_weekends || false,
      };
      setRepeatConfig(values);
      setSwitchStatesRepeat(true);
    } else {
      setRepeatConfig(null);
      setSwitchStatesRepeat(false);
    }

    // console.log("eventDatanew::::::", values)
  }, [eventData]);

  useEffect(() => {
    if (eventData?.color_id && colorMetaData && colorMetaData?.length > 0) {
      // console.log("eventData?.color",eventData.color, colorMetaData)
      const matchedColor = colorMetaData.find(
        (c) => c.id === eventData.color_id
      );
      // console.log("matchedColor", matchedColor)
      if (matchedColor) {
        setSelectedColor(matchedColor);
        setDescSelectedColor(matchedColor?.label_name);
        setSwitchStatesColor(true);
      }
    }
  }, [eventData, colorMetaData]);

  useEffect(() => {
    if (eventData?.task_master_id) {
      setTaskId(eventData?.task_master_id);
    }
    const getAssigneeData = eventData.assignees
      ?.map((a) => a.member?.invitee_nickname)
      .filter((name) => !!name) // filter out null/undefined
      .join(", ");
    setAssignName(getAssigneeData);

    const collaboratorsNameNew = eventData.collaborators
      ?.map((a) => a.member?.invitee_nickname)
      .filter((name) => !!name) // filter out null/undefined
      .join(", ");
    // console.log("getAssigneeData", eventData)

    if (!eventData?.assignees?.length) return;

    const assignees = eventData.assignees.map((assignee, index) => {
      return {
        id: assignee.member?.id || `temp-${index}`,
        name: assignee.member?.invitee_nickname || "Unknown",
      };
    });
    // console.log("selectedUsers", {selectedNames, AssignData, assignedUsers})
    if (assignees && assignees.length) {
      setAssignedUsers(assignees);
    }

    setCollaboratorsName(collaboratorsNameNew);
  }, [eventData]);

  useEffect(() => {
    if (getAssignee && getAssignee.length > 0) {
      const initialSelected = getAssignee.map((a) => a.member);
      setAssignedUsers(initialSelected); // ✅ Pre-select assignees
    }

    if (getCollaboraters && getCollaboraters.length > 0) {
      const initialSelected = getCollaboraters.map((collab) => ({
        ...collab.member,
        permission: collab.permission, // Include the permission data
      }));
      setSelectedCollaborators(initialSelected); // ✅ Pre-select assignees
    }
  }, [getAssignee, getCollaboraters]);

  useEffect(() => {
    if (!eventData?.collaborators?.length) return;

    // console.log("🔍 Raw eventData.collaborators:", eventData.collaborators);
    // console.log("🔍 Available permissions:", permission);

    const collaborators = eventData.collaborators.map((collab, index) => {
      const permissionId = Number(collab.permission_id);
      const matchedPermission = permission?.find(
        (p) => Number(p.id) === permissionId
      );

      return {
        id: collab.member?.id || `temp-${index}`,
        name: collab.member?.invitee_nickname,
        permission: matchedPermission,
      };
    });

    if (collaborators.length) {
      // console.log("✅ Final selected collaborators:", collaborators);
      setSelectedCollaborators(collaborators);
      setSwitchStatesCollaboration(true);
    }
  }, [eventData, permission]); // include `permission` in deps

  const fetchCollabaroteDate = async () => {
    try {
      const response = await fetch(`${URL}/v1/member/get-members-list`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        if (data?.data) {
          const { members, permissions } = data.data;

          const transformAssign = members.map((member) => ({
            id: Number(member.id),
            name: member.name,
            email: member.email,
            avatar: member.profile_image,
          }));

          const transformedCollaborators = members.map((member) => ({
            id: String(member.id),
            name: member.invitee_nickname,
            email: member.email,
            avatar: member.profile_image,
          }));

          const transformPermission = permissions;

          // console.log("AssignData", transformAssign);
          // console.log("transformPermission", transformPermission);

          setAssignData(transformAssign);
          setDummyCollaborators(transformedCollaborators);
          setPermission(transformPermission);
        }
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchCollabaroteDate();
  }, []);

  // console.log("taskId>>", taskId)
  const getCalenderMetaData = async () => {
    try {
      setMetaLoading(true); // Start loader
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.code == 200) {
        setProgressStatus(data.data.progress_status);
        setDisplayName(data.data.display_name);
        setPriority(data.data.priority);
        setRepeatOption(data.data.repeat_option);
        setColorMetaData(data.data.colors);
      } else {
        console.error("Invalid response from server:", data);
      }
    } catch (error) {
      // Optionally handle error
    } finally {
      setMetaLoading(false); // Stop loader
    }
  };

  useEffect(() => {
    getCalenderMetaData();
  }, []);

  const handleClose = () => {
    setEditView(false);
    onCancel(false);
  };
  const getLabelById = (list, id) => {
    if (id === 0 || id === null) return "No color";
    return list.find((item) => item.id === Number(id))?.label_name || "Unknown";
  };
  const statusLabel = getLabelById(
    progressStatus,
    taskDetails?.progress_status_id
  );
  const priorityLabel = getLabelById(priority, taskDetails?.priority_id);
  const displayLabel = getLabelById(displayName, taskDetails?.display_name_id);
  const colorLabel = getLabelById(colorMetaData, taskDetails?.color_id);

  const deleteTaskById = async (
    type,
    taskId,
    occurrenceDate,
    deleteType = "current"
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const payload = {
        delete_type: deleteType,
        ...(deleteType !== "all" && { occurrence_date: occurrenceDate }),
        id: eventData?.task_id,
      };

      const response = await axios.delete(
        `${URL}/v1/${type.toLowerCase()}/delete/${taskId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: payload,
        }
      );

      message.success("task deleted successfully");
      return response.data;
    } catch (error) {
      message.success("Error deleting task");
      console.error("Error deleting task:", error);
      throw error;
    }
  };
  const getReminderPresetLabel = (startTime, reminderTime) => {
    if (!startTime || !reminderTime) return "No reminder";
    const diffMinutes = moment(startTime).diff(moment(reminderTime), "minutes");
    if (diffMinutes === 5) return "5 minute before";
    if (diffMinutes === 30) return "30 minute before";
    if (diffMinutes === 60) return "1 hour before";
    if (diffMinutes === 1440) return "1 day before";
    if (diffMinutes > 0) return "Customize...";
    return "No reminder";
  };

  useEffect(() => {
    if (eventData?.type) {
      setEventType(eventData.type);
    }
  }, [eventData?.type]);

  useEffect(() => {
    if (eventData?.start) {
      setSelectedDate(moment.utc(eventData.start).format("D, MMMM YYYY"));
      setSwitchStates(true); // ✅ Enable switch if start date exists
    } else {
      setSelectedDate("No Date");
      setSwitchStates(false); // Reset switch if no date found
    }

    if (eventData?.start && eventData?.end) {
      setSelectedTime({
        start: moment.utc(eventData.start).format("HH:mm"),
        end: moment.utc(eventData.end).format("HH:mm"),
      });
      setSwitchTimeStates(true); // ✅ Enable switch if time exists
    } else {
      setSwitchTimeStates(false);
    }

    // ✅ Handle Reminder Time Calculation
    if (eventData?.reminder && eventData?.start) {
      // console.log("eventData?.reminder && eventData?.start",{eventData})
      // const reminderTime = moment.utc(eventData.reminder); // Convert reminder to UTC
      // const eventStartTime = moment.utc(eventData.start); // Convert event start to UTC

      // const diffMinutes = eventStartTime.diff(reminderTime, "minutes");
      // const diffHours = eventStartTime.diff(reminderTime, "hours");
      // const diffDays = eventStartTime.diff(reminderTime, "days");

      // let reminderText = "No reminder"; // Default value

      // if (diffDays === 0 && diffHours === 0) {
      //   reminderText = `${diffMinutes} minutes before`;
      // } else if (diffDays === 0) {
      //   reminderText = `${diffHours} hours, ${diffMinutes % 60} minutes before`;
      // } else {
      //   reminderText = `${diffDays} days, ${diffHours % 24} hours, ${diffMinutes % 60} minutes before`;
      // }
      let reminderText = eventData.reminder
        ? getReminderPresetLabel(eventData.start, eventData.reminder)
        : "No reminder";

      setDescSelectedReminder(reminderText);
      setSwitchStatesRem(true); // ✅ Enable switch if reminder exists
    } else {
      setDescSelectedReminder("No reminder");
      setSwitchStatesRem(false); // ✅ Disable switch if no reminder
    }
  }, [eventData?.start, eventData?.end, eventData?.reminder]);

  useEffect(() => {
    if (eventData?.reminder) {
      // console.log("🔄 Updating selectedReminder from eventData:", eventData.reminder);
      setSelectedReminder(eventData.reminder);
    }
  }, [eventData.reminder]);

  useEffect(() => {
    if (eventData?.title) {
      setInputText(eventData.title);
    } else {
      setInputText(""); // Fallback value
    }
  }, [eventData?.title]);

  useEffect(() => {
    if (eventData?.description) {
      setInputTextDesc(eventData.description);
    } else {
      setInputTextDesc(""); // Fallback value
    }
  }, [eventData?.description]);

  useEffect(() => {
    if (eventData?.location) {
      setLocationText(eventData.location);
    } else {
      setLocationText(""); // Fallback value
    }
  }, [eventData?.location]);

  useEffect(() => {
    if (eventData?.checklists) {
      setChecklist(
        eventData.checklists.map((item) => ({
          ...item,
          checked: item.is_checked === 1, // Convert is_checked to checked (boolean)
        }))
      );
    }
  }, [eventData?.checklists]);

  // console.log("checklist>>>>>", checklist)

  const handleEditOpen = () => {
    setEditView(true);
  };
  const handleviewOpen = () => {
    setEditView(false);
  };

  const handleChange = (e) => {
    // console.log("newdata", e)
    setInputText(e.target.value);
    setError(false); // Clear error when user types

    // Update state on input change
  };

  const handleChangeDesc = (e) => {
    setInputTextDesc(e.target.value); // Update state on input change
  };
  const handleChangeLocation = (e) => {
    setLocationText(e.target.value); // Update state on input change
  };

  useEffect(() => {
    // console.log("Deleted checklist IDs in parent updated:", deletedChecklistIds);
  }, [deletedChecklistIds]);
  // useEffect(() => {
  //   console.log("Deleted IDs in parent:", deletedChecklistIds);
  // }, [deletedChecklistIds]);
  useEffect(() => {
    if (eventData.displaynameId) {
      setSelectedDisplayId(Number(eventData.displaynameId));
    }
    if (eventData.priorityId) {
      setSelectedPriorityIds(Number(eventData.priorityId));
    }
    if (eventData.progressStatusId) {
      const selectedStatus = progressStatus.find(
        (status) => status.id == eventData.progressStatusId
      );
      if (selectedStatus) {
        setSelectedRadio(selectedStatus.id);
      }
    }
  }, [
    eventData.displaynameId,
    eventData.priorityId,
    eventData.progressStatusId,
    progressStatus,
  ]);

  const handleRadioChange = (e) => {
    setSelectedRadio(e.target.value);
  };

  const handleUpdateApply = async (
    type,
    taskId,
    occurrenceDate,
    update_type = "current"
  ) => {
    if (!inputText && !inputText.trim()) {
      setError(true);
      message.error("Task name is required!");
      return;
    }

    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );
    let formattedDate = moment(
      formattedStartDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );

    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    let formattedStartTime = moment(
      selectedTime?.start,
      ["HH:mm", "HH:mm:ss"],
      true
    );
    const taskStartTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime.format(
          "HH:mm"
        )}`
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    let formattedEndTime = moment(
      selectedTime?.end,
      ["HH:mm", "HH:mm:ss"],
      true
    );
    const taskEndTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime.format(
          "HH:mm"
        )}`
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    // console.log("formattedStartDate", taskEndTime)
    const formattedReminder = moment(
      selectedReminder,
      "YYYY-MM-DD HH:mm"
    ).format("YYYY-MM-DDTHH:mm:ss[Z]");

    const checkListItems =
      checklist?.map(
        ({ checklist_id, title, description = null, checked, new_status }) => ({
          checklist_id: new_status ? null : checklist_id,
          title,
          description,
          is_checked: checked ? 1 : 0,
        })
      ) || [];
    // console.log("eventType>>>>>", checkListItems)
    // Determine if it's a task or event and structure the payload accordingly

    const calculateEndDate = (repeatConfig) => {
      if (!repeatConfig || !formattedStartDate) return null;
      const { endType, occurrences, customEndDate } = repeatConfig;
      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }
      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };
    // console.log("update_type", update_type, occurrenceDate);
    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );

    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }
    const payload = {
      title: inputText,
      location: locationText,
      description: inputTextDesc,
      display_name_id: selectedDisplayId,
      priority_id: selectedPriorityIds,
      progress_status_id: selectedRadio,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      end_time: taskEndTime,
      reminder_timestamp: switchStatesRem ? formattedReminder : null,
      deleted_check_list: deletedChecklistIds,
      repeat_option:
        update_type == "current"
          ? null
          : repeatConfig?.repeatType?.value || null,
      repetition_end_date:
        update_type == "current"
          ? null
          : repeatConfig?.endType === "custom"
          ? moment(repeatConfig.customEndDate).format("YYYY-MM-DD")
          : calculateEndDate(repeatConfig),
      exclude_saturdays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "saturday"
      )
        ? true
        : false,
      exclude_sundays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "sunday"
      )
        ? true
        : false,
      adjust_weekends: adjustWeekendsValue,
      color_id: switchStatesColor ? selectedColor?.id : null,
      assignees: assignedUsers && assignedUsers?.map((user) => user.id),
      collaborators:
        selectedCollaborators &&
        selectedCollaborators?.map((collaborator) => {
          return {
            member_id: parseInt(collaborator?.id),
            permission_id: collaborator?.permission?.id,
          };
        }),
      ...(eventType === "event" && { check_list: checkListItems }), // Only add checklist for events
      // update_type: "all",
      occurrence_date: moment(eventData.start).format("YYYY-MM-DD"),
      update_type: repeatConfig?.repeatType?.value ? update_type : "current",
      invitees: invitees,
    };
    // console.log("pyupdatepayload", payload)
    // return
    try {
      const response = await fetch(`${URL}/v1/${eventType}/update/${taskId}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.code === 200) {
        message.success(`${eventType} updated successfully`);
        handleClose();
        onSuccess();
      } else {
        message.error(response.data.message || "Failed to update Event");
      }
    } catch (error) {
      console.error("Error updating task:", error);
      message.error(
        error?.response?.data?.message ||
          error.message ||
          "Error updating event"
      );
    }
  };

  // confirm update
  const handleUpdateEvent = async (type, taskOReventId, occurrenceDate) => {
    setSelectedItemForDelete({
      type,
      id: taskOReventId,
      occurrenceDate,
    });
    if (eventData.repeat_option) {
      setIsUpdateModalVisible(true);
    } else {
      // const { type, id, occurrenceDate } = selectedItemForDelete ? selectedItemForDelete : null;
      await handleUpdateApply(type, taskOReventId, occurrenceDate, "all");
    }
  };

  const handleConfirmUpdate = async (payload) => {
    try {
      const { type, id, occurrenceDate } = selectedItemForDelete;
      await handleUpdateApply(type, id, occurrenceDate, payload.update_type);
    } catch (err) {
      console.error("Failed to update task", err);
    } finally {
      setIsUpdateModalVisible(false);
      onCancel();
      onSuccess();
    }
  };

  // console.log("colorMetaData", colorMetaData)
  function getColorLabelById(id) {
    const color = colorMetaData.find((color) => color.id === id);
    return color;
  }

  // console.log("getColorLabelById", getColorLabelById(45)?.label_name)

  // console.log("repeatOption", repeatConfig)
  // console.log("assignedUsers", assignedUsers)
  // console.log("selectedCollaborators", selectedCollaborators)

  // const handleConfirmDelete = async () => {
  //   try {
  //     await deleteTaskById(taskId, occurrenceDate, "all");
  //   } catch (err) {
  //     console.error("Failed to delete task", err);
  //   } finally {
  //     setIsModalVisible(false);
  //     onCancel();
  //     onSuccess()

  // }
  // };
  const handleDeleteTaskEvent = async (type, taskOReventId, occurrenceDate) => {
    if (eventData.repeat_option) {
      setSelectedItemForDelete({
        type,
        id: taskOReventId,
        occurrenceDate,
      });
      setIsModalVisible(true);
    } else {
      setSelectedItemForDelete({
        type,
        id: taskOReventId,
        occurrenceDate,
      });
      // Directly delete if not recurring
      setIsDeleteModalVisible(true);
      // setIsModalVisible(true)
      // try {
      //   await deleteTaskById(type, taskOReventId, occurrenceDate, "all");
      //   onCancel();    // Close modal
      //   onSuccess && onSuccess(); // Callback if provided
      // } catch (err) {
      //   // Optionally handle error
      //   console.error("Failed to delete task", err);
      // }
    }
  };

  const handleConfirmDelete = async (payload) => {
    // console.log("payload", payload);
    try {
      const { type, id, occurrenceDate } = selectedItemForDelete;
      await deleteTaskById(
        type,
        id,
        occurrenceDate,
        payload?.update_type || "current"
      );
    } catch (err) {
      console.error("Failed to delete task", err);
    } finally {
      setIsModalVisible(false);
      onCancel();
      onSuccess();
    }
  };

  // console.log("getCollaboraters", {getCollaboraters, getAssignee});

  const iconStyle = { fontSize: 22, color: "#666", marginRight: 8 };
  const subTextStyle = { marginLeft: 30, color: "#555" };

  const listItemStyle = {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
  };

  const rowStyle = {
    display: "flex",
    alignItems: "center",
    width: "100%",
  };

  useEffect(() => {
    if (selectedCollaborators.length > 0) {
      setSwitchStatesCollaboration(true);
    }
  }, [selectedCollaborators]);

  // collaborators={dummyCollaborators}
  // initialSelected={selectedCollaborators}
  // permissionMetadata={permission}
  // console.log("selectedCollaborators", selectedCollaborators, invitees)
  // console.log("collabModalData", {dummyCollaborators, selectedCollaborators, permission})

  return (
    <div>
      <Modal
        open={isOpen}
        onCancel={handleClose}
        footer={null}
        centered
        width={500}
        maskClosable={false}
      >
        {metaLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 200,
            }}
          >
            <span>Loading...</span>
            {/* Or use <Spin size="large" /> from antd for a spinner */}
          </div>
        ) : !editView ? (
          <div style={{ marginTop: 20 }}>
            {/* Header Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <h3 level={4} style={{ textTransform: "capitalize" }}>
                {eventType}
              </h3>
              {(taskDetails?.permission === null ||
                taskDetails?.permission?.id == 6) && (
                <div style={{ marginBottom: 10 }}>
                  <Button
                    type="primary"
                    icon={<EditOutlined />}
                    style={{ marginRight: 8 }}
                    onClick={handleEditOpen}
                  >
                    Edit Task
                  </Button>
                  <Button
                    type="text"
                    onClick={() =>
                      handleDeleteTaskEvent(
                        eventData?.type,
                        eventData?.event_master_id || eventData?.task_master_id,

                        moment(selectedDate, "D, MMMM YYYY").format(
                          "YYYY-MM-DD"
                        )
                      )
                    }
                    icon={<DeleteOutlined style={{ color: "#9A4FE0" }} />}
                    className="add-task-checklist-btn"
                  />
                </div>
              )}
            </div>

            {/* Task Name & Description */}
            <h3 style={{ marginTop: "5px" }} level={5}>
              <strong>Title</strong> : {inputText}
            </h3>

            <div style={{ marginTop: "5px" }}>
              <Text>
                <strong>Description</strong> : {inputTextDesc}
              </Text>
            </div>

            <div>
              <Paragraph style={{ marginTop: "5px" }}>
                <strong>Location: </strong>
                {locationText}
              </Paragraph>
            </div>

            {eventType === "event" && checklist?.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <h3 level={5}>Checklists</h3>

                <List
                  dataSource={checklist} // Map over checklists array
                  renderItem={(item) => (
                    <List.Item
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <img
                        src={CheckboxLogo}
                        width={24}
                        style={{ marginRight: "10px" }}
                      />
                      {item.title}
                    </List.Item>
                  )}
                />
              </div>
            )}

            {/* Status & Priority */}
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }} level={5}>
                Status
              </h3>
              <Tag className="ant-tag-btn">{statusLabel}</Tag>
            </div>
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }} level={5}>
                Preferred Display Name
              </h3>
              <Tag className="ant-tag-btn">{displayLabel}</Tag>
            </div>

            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }} level={5}>
                Priority
              </h3>
              <Tag className="ant-tag-btn">{priorityLabel}</Tag>
            </div>
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
                Assigned by
              </h3>
              <Tag className="ant-tag-btn">
                {(assignBy && assignBy?.name) || ""}{" "}
              </Tag>
            </div>
            {/* Task Details */}
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold" }} level={5}>
                Detail
              </h3>
              <List>
                <List.Item style={listItemStyle}>
                  <div style={rowStyle}>
                    <CalendarOutlined style={iconStyle} />
                    <Text style={{ fontWeight: 500 }}>Assignees</Text>
                  </div>
                  <Text style={subTextStyle}>
                    {getAssignee?.length
                      ? getAssignee.map((c) => c?.member?.name).join(", ")
                      : "No Assignees"}
                  </Text>
                </List.Item>

                <List.Item style={listItemStyle}>
                  <div style={rowStyle}>
                    <TeamOutlined style={iconStyle} />
                    <Text style={{ fontWeight: 500 }}>Collaboration</Text>
                  </div>
                  <Text style={subTextStyle}>
                    {getCollaboraters?.length
                      ? getCollaboraters.map((c) => c?.member?.name).join(", ")
                      : "No Collaborators"}
                  </Text>
                </List.Item>

                <List.Item style={listItemStyle}>
                  <div style={rowStyle}>
                    <CalendarOutlined style={iconStyle} />
                    <Text style={{ fontWeight: 500 }}>Date</Text>
                  </div>
                  <Text style={subTextStyle}>{selectedDate}</Text>
                </List.Item>

                <List.Item style={listItemStyle}>
                  <div style={rowStyle}>
                    <ClockCircleOutlined style={iconStyle} />
                    <Text style={{ fontWeight: 500 }}>Time</Text>
                  </div>
                  <Text style={subTextStyle}>
                    {selectedTime.start && selectedTime.end
                      ? `${selectedTime.start} - ${selectedTime.end}`
                      : "Not Set"}
                  </Text>
                </List.Item>

                <List.Item style={listItemStyle}>
                  <div style={rowStyle}>
                    <BellOutlined style={iconStyle} />
                    <Text style={{ fontWeight: 500 }}>Reminder</Text>
                  </div>
                  <Text style={subTextStyle}>
                    {descSelectedReminder === "No reminder"
                      ? "No Reminder"
                      : descSelectedReminder}
                  </Text>
                </List.Item>

                <List.Item style={listItemStyle}>
                  <div style={rowStyle}>
                    <RepeatOnOutlined style={iconStyle} />
                    <Text style={{ fontWeight: 500 }}>Repeat</Text>
                  </div>
                  <Text style={subTextStyle}>
                    {eventData?.repeat_option
                      ? `${eventData.repeat_option
                          .charAt(0)
                          .toUpperCase()}${eventData.repeat_option.slice(1)}`
                      : "No Repeat"}{" "}
                    {eventData?.repetition_end_date &&
                      `(End until ${moment(
                        eventData.repetition_end_date
                      ).format("D, MMMM YYYY")})`}
                  </Text>
                </List.Item>

                <List.Item style={listItemStyle}>
                  <div style={rowStyle}>
                    <ColorLensOutlinedIcon style={iconStyle} />
                    <Text style={{ fontWeight: 500 }}>Colors</Text>
                  </div>
                  <Text style={subTextStyle}>
                    {(eventData &&
                      getColorLabelById(eventData?.color_id)?.label_name) ||
                      "No Color"}
                  </Text>
                </List.Item>
              </List>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: 20 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
                marginBottom: 10,
              }}
            >
              <h3 level={4} style={{ textTransform: "capitalize" }}>
                <EditOutlined /> Edit {eventType}
              </h3>
              <div>
                <Button className="reset-btn" onClick={handleviewOpen}>
                  Cancel
                </Button>
              </div>
            </div>
            <div className="addTaskLabel">
              <FloatLabel
                label="What is the name of your task"
                name="taskTitle"
                value={inputText}
              >
                <Input value={inputText} onChange={handleChange} />
              </FloatLabel>
              {/* {error && <Text type="danger">{tabName} Name is required!</Text>} */}
            </div>

            <FloatLabel
              label="Description"
              name="taskDescription"
              value={inputTextDesc}
            >
              <Input.TextArea
                value={inputTextDesc}
                onChange={handleChangeDesc}
                autoSize={{ minRows: 1, maxRows: 6 }}
              />
            </FloatLabel>

            <FloatLabel
              label="Location"
              name="taskLocation"
              value={locationText}
            >
              <Input value={locationText} onChange={handleChangeLocation} />
            </FloatLabel>
            {/* <div>
         <h3> User Assign </h3>
         <List
    dataSource={checkListItems} // Map over checklists array
    renderItem={(item) => (
      <List.Item style={{ display: "flex", alignItems: "center",justifyContent:'flex-start' }}>
        <img src={CheckboxLogo} width={24} style={{marginRight:'10px'}} />
         {item.title}
      </List.Item>
    )}
  />
         </div> */}
            {eventType === "event" && checklist?.length > 0 && (
              <ChecklistComponent
                checklist={checklist}
                setChecklist={setChecklist}
                deletedChecklistIds={deletedChecklistIds}
                setDeletedChecklistIds={setDeletedChecklistIds}
              />
            )}
            <div style={{ marginTop: 16 }}>
              <div className="radio-container">
                <h3
                  style={{ marginBottom: 0, fontSize: 16 }}
                  className="radio-label"
                >
                  Status
                </h3>
                <Radio.Group
                  className="custom-radio-group"
                  onChange={handleRadioChange}
                  value={selectedRadio}
                >
                  {progressStatus.length > 0 &&
                    progressStatus.map((status) => (
                      <Radio
                        key={status.id}
                        value={status.id}
                        className="custom-radio"
                      >
                        {status.label_name}
                      </Radio>
                    ))}
                </Radio.Group>
              </div>
            </div>

            <div>
              <h3 style={{ marginBottom: 5, fontWeight: "bold" }}>
                Preferred Display Name
              </h3>
              {displayName.map((status) => (
                <Tag
                  onClick={() => handleSelectDisplay(status.id)}
                  style={{
                    backgroundColor:
                      selectedDisplayId === status.id ? "#FEF1FE" : "#ffffff",
                    color: selectedDisplayId === status.id ? "#9A4FE0" : "#000",
                    border:
                      selectedDisplayId === status.id
                        ? "1px solid #9A4FE0"
                        : "1px solid #E1E6EF",
                    borderRadius: "10px",

                    cursor: "pointer",
                    fontSize: "14px",
                    padding: "8px 12px",
                    lineHeight: "18px",
                  }}
                  key={status.id}
                >
                  {status.label_name}
                </Tag>
              ))}
            </div>
            <div style={{ marginTop: 16 }}>
              <h3 style={{ marginBottom: 5, fontWeight: "bold" }}>
                Assigned by
              </h3>
              <Tag className="ant-tag-btn">
                {(assignBy && assignBy?.name) || ""}{" "}
              </Tag>
            </div>
            <div style={{ marginTop: 16 }}>
              <h3 style={{ marginBottom: 5, fontWeight: "bold" }}>Priority</h3>
              {priority.length > 0 ? (
                priority.map((status) => (
                  <Tag
                    onClick={() => handleSelectPriority(status.id)}
                    style={{
                      backgroundColor:
                        selectedPriorityIds === status.id
                          ? "#FEF1FE"
                          : "#ffffff",
                      color:
                        selectedPriorityIds === status.id ? "#9A4FE0" : "#000",
                      border:
                        selectedPriorityIds === status.id
                          ? "1px solid #9A4FE0"
                          : "1px solid #E1E6EF",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontSize: "14px",
                      padding: "8px 12px",
                      lineHeight: "18px",
                    }}
                    key={status.id}
                  >
                    {status.label_name}
                  </Tag>
                ))
              ) : (
                <p>Loading...</p> // Optional loading state
              )}
            </div>
            <div style={{ marginTop: 16 }}>
              <div className="details-container">
                <h3 style={{ marginBottom: 5 }} className="details-title">
                  Details
                </h3>
                <DetailsList
                  icon={<AssignmentOutlined style={iconStyle} />}
                  title="Assign To"
                  description={selectedNames}
                  switchChecked={assignedUsers?.length > 0}
                  onSwitchChange={() => setShowAssignModal(true)}
                  onClick={() => setShowAssignModal(true)}
                />
                <DetailsList
                  icon={<AssessmentOutlined style={iconStyle} />}
                  title="Collaborators"
                  description={descSelectedCollaboration}
                  switchChecked={switchStatesCollaboration}
                  onSwitchChange={() => {
                    // Always open modal instead of toggling
                    setShowCollaborationModal(true);
                  }}
                  onClick={() => {
                    if (switchStatesCollaboration) {
                      setShowCollaborationModal(true);
                    }
                  }}
                />
                <DetailsList
                  icon={<CalendarOutlined style={iconStyle} />}
                  title="Date"
                  description={selectedDate || "No date selected"}
                  switchChecked={switchStates}
                  onSwitchChange={() => handleSwitchChange()}
                  onClick={() => setShowModal(true)} // Open modal on click
                />
                {/* {console.log("selectedTimeNew", selectedTime)} */}
                <DetailsList
                  icon={<ClockCircleOutlined style={iconStyle} />}
                  title="Time"
                  description={
                    selectedTime.start && selectedTime.end
                      ? `${selectedTime.start} - ${selectedTime.end}`
                      : "Not Set"
                  }
                  switchChecked={switchTimeStates}
                  onSwitchChange={() => handleSwitchChangeTime()}
                  onClick={() => setShowTimeModal(true)}
                />

                <DetailsList
                  icon={<BellOutlined style={iconStyle} />}
                  title="Reminder"
                  description={
                    descSelectedReminder === "No reminder"
                      ? "No Reminder"
                      : descSelectedReminder
                  }
                  switchChecked={switchStatesRem}
                  onSwitchChange={handleSwitchChangeRem}
                  onClick={() => setShowRemModal(true)}
                />
                <DetailsList
                  icon={<RepeatOnOutlined style={iconStyle} />}
                  title="Repeat"
                  description={getRepeatDescription()}
                  switchChecked={switchStatesRepeat}
                  onSwitchChange={handleSwitchChangeRepeat}
                  onClick={() => setShowRepeatModal(true)}
                />
                <DetailsList
                  icon={<ColorLensOutlined style={iconStyle} />}
                  title="Color"
                  description={descSelectedColor}
                  switchChecked={switchStatesColor}
                  onSwitchChange={handleSwitchChangeColor}
                  onClick={() => setShowColorModal(true)}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
                gap: "5px",
              }}
            >
              <Button className="modal-cancel-btn" onClick={handleviewOpen}>
                Cancel
              </Button>
              <Button
                type="primary"
                className="modal-success-btn"
                // onClick={handleUpdateApply}
                onClick={() =>
                  handleUpdateEvent(
                    eventData?.type,
                    eventData?.event_master_id || eventData?.task_master_id,
                    moment(selectedDate, "D, MMMM YYYY").format("YYYY-MM-DD")
                  )
                }
              >
                Apply
              </Button>
            </div>
          </div>
        )}
      </Modal>

      {isDeleteModalVisible && (
        <DeleteConfirmationModal
          visible={isDeleteModalVisible}
          onConfirm={handleConfirmDelete}
          // onCancel={() => setIsModalVisible(false)}
          onCancel={() => setIsDeleteModalVisible(false)}
        />
      )}

      {isModalVisible && (
        <RecurringEventModal
          visible={isModalVisible}
          action="delete"
          occurrenceDate={selectedItemForDelete?.occurrenceDate}
          onClose={() => setIsModalVisible(false)}
          onConfirm={handleConfirmDelete}
        />
      )}
      <RecurringEventModal
        visible={isUpdateModalVisible}
        action="update"
        occurrenceDate={selectedItemForDelete?.occurrenceDate}
        onClose={() => setIsUpdateModalVisible(false)}
        onConfirm={handleConfirmUpdate}
      />

      <div>
        {/* <DateCalender isOpen={isCalendarOpen} onClose={() => setIsCalendarOpen(false)} onSelectDate={handleSelectDate} /> */}
        <DateModalTask
          show={showModal}
          handleClose={() => setShowModal(false)}
          onDateSelect={handleDateSelect}
          selectedDate={selectedDate}
        />
      </div>

      <div>
        <TimeSelect
          show={showTimeModal}
          handleClose={() => setShowTimeModal(false)}
          onSelectTime={handleSelectTime}
          selectedTime={selectedTime}
          selectedDate={selectedDate}
        />
      </div>
      <div>
        <Reminder
          show={showRemModal}
          handleClose={() => setShowRemModal(false)}
          onSelectReminder={handleSelectReminder}
          eventDate={selectedDate}
          eventTime={selectedTime}
          selectReminderTime={selectTextReminder}
          initialReminder={descSelectedReminder}
          eventData={eventData}
        />
        <AssignToModal
          visible={showAssignModal}
          onCancel={() => setShowAssignModal(false)}
          onSave={(newSelection) => {
            setAssignedUsers(newSelection);
            setShowAssignModal(false);
          }}
          // selectedUsers={ getAssignee || assignedUsers}
          selectedUsers={getAssignee.map((a) => a.member)}
          users={AssignData}
        />
        <CollaborationModal
          visible={showCollaborationModal}
          onCancel={() => {
            setSelectedCollaborators([]);
            setShowCollaborationModal(false);
          }}
          onSave={handleSaveCollaboration}
          collaborators={dummyCollaborators}
          initialSelected={selectedCollaborators}
          permissionMetadata={permission}
          // tabName={tabName} // <-- Pass the tab name here
        />
        <RepeatModal
          visible={showRepeatModal}
          onCancel={handleRepeatCancel}
          onSave={handleRepeatSave}
          initialValues={repeatConfig}
          repeatOption={repeatOption}
          adjustWeeknd={adjusWeekend}
          startDate={selectedDate} // 👈 This must be defined above this point
        />
        <ColorsModal
          visible={showColorModal}
          onCancel={handleColorCancel}
          onSave={handleColorSave}
          metaData={colorMetaData}
          initialSelectedColor={selectedColor}
        />
      </div>
    </div>
  );
};

export default ViewTask;
